/**
 * TanStack Query hooks for `igaming-s2s-pipeline`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingS2sPipelineQueryKeys,
	type CreateIgamingS2sPipelineBody,
	type ListIgamingS2sPipelineResponse,
	type IgamingS2sPipelineRow,
} from "./api";

export function useIgamingS2sPipelineList(): UseQueryResult<ListIgamingS2sPipelineResponse, Error> {
	return useQuery({
		queryKey: igamingS2sPipelineQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingS2sPipelineCreate(): UseMutationResult<IgamingS2sPipelineRow, Error, CreateIgamingS2sPipelineBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingS2sPipelineQueryKeys.all });
		},
	});
}

export function useIgamingS2sPipelineDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingS2sPipelineQueryKeys.all });
		},
	});
}
